import React, { useContext } from "react";
import { Grid, List, ListItem, ListItemText, ListItemIcon, Card, Box, Typography } from '@material-ui/core';


import translate from "../i18n/Translator";
import { AppContext } from "../context/AppContext";
import { Issuer, Receptor } from "../model/Cfdi";
import { ApartmentIcon, HomeWorkIcon } from "../components/Icons";
import { TaxRegimens } from "../model/TaxRegimen";

export interface CompanyInfo {
    company_name?: string,
    company_rfc?: string
}

interface PayableDocumentIssuerWidgetProps {
    issuer: Issuer;
    tax_id?: string;
    receptor?: Receptor;
    issuerTaxRegimen?: string;
    taxRegimens: TaxRegimens;
    company?: CompanyInfo
}

export default function PayableDocumentIssuerWidget(props: PayableDocumentIssuerWidgetProps) {
    const context = useContext(AppContext);
    const getTaxRegimens = (taxRegimen: string) => {
        if (taxRegimen) {
            return props.taxRegimens.items.find(e => e.id === taxRegimen)?.description ?? "";
        }
        return ""
    }

    return (
        <Card variant="outlined">
            <Box pl={2} pt={2} pb={2}>
                <Grid container alignItems="center" alignContent="center">
                    <Grid item xs={12}>
                        <strong>{translate("cfdis.details.emitter")}</strong>
                    </Grid>
                    <Grid item xs={12}>
                        <List component="nav" dense>
                            <ListItem>
                                <ListItemIcon>
                                    <ApartmentIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary={props.issuer.name}
                                    secondary={
                                        props.issuerTaxRegimen ?
                                            <div >
                                                <Typography variant="inherit" color="inherit">{props.tax_id ? props.tax_id : props.issuer.rfc}</Typography>
                                                <br />
                                                <Typography variant="body2" color="inherit" style={italic()}>{props.issuerTaxRegimen + " - " + getTaxRegimens(props.issuerTaxRegimen)}</Typography>
                                            </div> :
                                            props.tax_id ? props.tax_id : props.issuer.rfc
                                    } />
                            </ListItem>
                        </List>
                    </Grid>
                </Grid>

                <Grid container alignItems="center" alignContent="center">
                    <Grid item xs={12}>
                        <strong>{translate("cfdis.details.receiver")}</strong>
                    </Grid>
                    <Grid item xs={12}>
                        <List component="nav" dense>
                            <ListItem>
                                <ListItemIcon>
                                    <HomeWorkIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary={props.receptor?.nombre || props.company?.company_name || context.session!.tenant!.name}
                                    secondary={
                                        props.receptor?.rfc ?
                                            <div >
                                                <Typography variant="inherit" color="inherit">{props.receptor.rfc}</Typography>
                                                <br />
                                                {props?.receptor?.regimen_fiscal_receptor && <Typography variant="body2" color="inherit" style={italic()}>{props.receptor.regimen_fiscal_receptor + " - " + getTaxRegimens(props.receptor.regimen_fiscal_receptor)}</Typography>}
                                                <Typography variant="body2" color="inherit" >{`${translate(`cfdis.use_cfdi`)}: ${props.receptor.uso_cfdi} - ${translate(`reception_rule.cfdi_uses.${props.receptor?.uso_cfdi}`)}`}</Typography>
                                            </div>
                                            : props.company?.company_rfc ? props.company.company_rfc : context.session!.tenant!.rfc
                                    } />
                            </ListItem>
                        </List>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
}

function italic(): React.CSSProperties | undefined {
    return { fontStyle: 'italic' };
}
